import React from "react";
import { styled } from "@glitz/react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import CloseIcon from "./CloseIcon";
import { spacing, lightGrey, Size, grey, fontSize, fontWeight } from "../theme";
import Button from "./basic/Button";
import CartItem from "../components/CartItems";

type MiniCartProps = {
  isOpen: boolean;
  onClose: () => void;
};

const MiniCart: React.FC<MiniCartProps> = ({ isOpen, onClose }) => {
  const { getTotalPrice, getFinalPrice, packageFeeTotal } = useCart();
  const navigate = useNavigate();

  return (
    <>
      {isOpen && (
        <MiniCartWrapper css={isOpen ? openDecoration : closedDecoration}>
          <Top>
            <h2>Din varukorg</h2>
            <CloseIcon onClose={onClose} />
          </Top>
          <Content>
            <CartItem />
          </Content>
          <Bottom>
            <TotalSum>
              <span>Totalt</span>
              <span>
                {packageFeeTotal !== 0 ? (
                  <>
                    <ListPrice>{getTotalPrice()} kr</ListPrice> {getFinalPrice()} kr
                  </>
                ) : (
                  `${getFinalPrice()} kr`
                )}
              </span>
            </TotalSum>
            <ButtonWrapper>
              <Button onClick={onClose} size={Size.Small} ghost>
                Fortsätt Handla
              </Button>
              <Button onClick={() => navigate(`/checkout`)} size={Size.Small}>
                Till Kassan
              </Button>
            </ButtonWrapper>
          </Bottom>
        </MiniCartWrapper>
      )}
    </>
  );
};

const closedDecoration = styled({
  transform: "translateX(0)",
});

const openDecoration = styled({
  transform: "translateX(100%)",
});

const Top = styled.div({
  display: "flex",
  justifyContent: "space-between",
  paddingLeft: spacing.s,
});

const Content = styled.div({
  maxHeight: "100%",
  minHeight: "70%",
  display: "flex",
  paddingLeft: spacing.s,
  overflow: "auto",
  marginBottom: spacing.m,
});

const Bottom = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
  padding: { xy: spacing.s },
  borderTop: { style: "solid", color: grey, width: "1px" },
});

const ButtonWrapper = styled.div({
  display: "flex",
  justifyContent: "space-evenly",
});

const TotalSum = styled.div({
  display: "flex",
  fontSize: fontSize.l,
  fontWeight: fontWeight.bold,
  justifyContent: "space-between",
});

const ListPrice = styled.span({
  textDecoration: "line-through",
  opacity: 0.65,
  marginRight: spacing.xs,
  fontWeight: fontWeight.regular,
});

const MiniCartWrapper = styled.div({
  width: "400px",
  height: "100vh",
  backgroundColor: lightGrey,
  borderLeft: { style: "solid", color: grey, width: "2px" },
  position: "fixed",
  top: 0,
  right: "400px",
  zIndex: 1200,
  transitionProperty: "transform",
  transitionDuration: "0.7s",
  transitionTimingFunction: "ease-in-out",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
});

export default MiniCart;
